<template>
  <div class="Questionnaire">
    <QuestionnaireSingle />
  </div>
</template>

<script>
// @ is an alias to /src
import QuestionnaireSingle from '@/components/QuestionnaireSingle/Main.vue'
import i18n from '../i18n'

export default {
  name: 'Questionnaire',
  title: i18n.locale === 'en' ? 'Questionnaire' : 'Ερωτηματολόγιο',
  components: {
    QuestionnaireSingle
  }
}
</script>
